module.exports = __webpack_public_path__ + "61ae216e670ebbfba4dd6aae1fbf505d.pdf";